import { Text } from '@fluentui/react-components';
import { useSummaryCardSectionStyles } from './SummaryCard.styles';
import { useMemo } from 'react';
import { ICostSummaryItem } from '../../../contexts/CartContext/CartContext.types';

export interface ISummaryCardSectionProps {
    title: string;
    rows: ICostSummaryItem[];
    totalText: string;
}

const SummaryCardSection = (props: ISummaryCardSectionProps) => {
    const { title, rows, totalText } = props;

    const styles = useSummaryCardSectionStyles();

    const total = useMemo(() => {
        if (!rows) {
            return 0;
        }

        let sum = 0;

        const calculateSum = (items: ICostSummaryItem[]) => {
            items.forEach((x) => {
                if (x.type != 'display') {
                    sum += x.amount;
                }

                if (x.children) {
                    calculateSum(x.children);
                }
            });
        };

        calculateSum(rows);

        return sum;
    }, [rows]);

    const renderRows = (items: ICostSummaryItem[], indent: number = 0) => {
        return items.map((x) => (
            <div key={x.itemName}>
                <div className={styles.lineItem} style={{ marginLeft: `${indent * 20}px` }}>
                    <Text size={300}>{x.itemName}</Text>
                    <Text size={300}>{x.type != 'display' && `$${x.amount.toFixed(2)}`}</Text>
                </div>
                {x.sku?.toLowerCase() == 'act_fee' && (
                    <Text size={200} italic className={styles.feeDisclaimer}>
                        Will appear on your first bill, if applicable.
                    </Text>
                )}
                {x.children && renderRows(x.children, indent + 1)}
            </div>
        ));
    };

    return (
        <div className={styles.root}>
            <Text size={400} weight='semibold'>
                {title}
            </Text>

            {rows && renderRows(rows)}

            <div className={styles.lineItem}>
                <Text size={400} weight='semibold'>
                    {totalText}
                </Text>
                <Text size={300} weight='semibold'>{`$${total.toFixed(2)}`}</Text>
            </div>
        </div>
    );
};

export default SummaryCardSection;
